import { Form as FormikForm } from 'formik';
import styled, { css } from 'styled-components';
import {
  FlexLayout,
  ChatSection,
  AddButton as TCAddButton,
} from '@gv/triage-components';

export const ChatRoom = styled(ChatSection)`
  flex: 1;
  min-width: 0;

  > &:first-child {
    padding: 0;
  }
`;

export const Container = styled(FlexLayout)`
  width: 100%;
  height: 100%;
  min-height: 0;

  ${({ theme }) =>
    theme.responsive.isMobile &&
    css`
      flex-direction: column;
    `}
`;

export const Content = styled(FlexLayout)`
  flex: 1;
  height: 100%;
  min-width: 0;
  min-height: 0;
  position: relative;
  flex-direction: column;
`;

export const AddButton = styled(TCAddButton)`
  margin: 0;
`;

export const Inner = styled.div<{ paddingTop?: number }>`
  position: relative;
  height: 100%;
  overflow-y: auto;
  ${({ paddingTop }) => css`
    padding: ${paddingTop ? `${paddingTop}px 24px 0 24px` : '0 24px'};
  `}
`;

export const Form = styled(FormikForm)`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow-x: hidden;
`;
